"use client";

import { useSessionLoginListener } from "@/hooks/useSessionLoginListener";

// Renders nothing; exists so the server-rendered (auth) layout can mount the
// cross-tab login listener without becoming a client component itself.
export const SessionLoginListener: React.FC = () => {
  useSessionLoginListener();
  return null;
};
